import { Heading, HeadingProps } from '@chakra-ui/react';
import React from 'react';

export const Header = (props: HeadingProps) => {
  return <Heading {...props} />;
};
